import React from "react";
import { useTranslation } from "react-i18next";
import { ExclamationCircleIcon } from "@heroicons/react/outline";
import { getErrorMessages } from "../../../Utils";

// What a list, report or section shows in place of its data when loading it
// failed: one look on every page, with the server's reason and a retry.
// Secondary loads that sit beside real data use FormError with onRetry instead.
const LoadErrorState = ({ error, onRetry, title = "common.errors.loads.data" }) => {
  const { t } = useTranslation();
  const messages = getErrorMessages(error, t);

  return (
    <div className="text-center py-12" role="alert">
      <ExclamationCircleIcon className="mx-auto h-12 w-12 text-red-400" />
      <h3 className="mt-2 text-sm font-medium text-gray-900">{t(title)}</h3>
      {messages.length === 1 ? (
        <p className="mt-1 text-sm text-gray-500">{messages[0]}</p>
      ) : (
        <ul className="mt-1 text-sm text-gray-500 list-disc list-inside">
          {messages.map((message, index) => (
            <li key={index}>{message}</li>
          ))}
        </ul>
      )}
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-4 inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-indigo-500"
        >
          {t("common.tryAgain")}
        </button>
      )}
    </div>
  );
};

export default LoadErrorState;
